import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { exampleTitle, exampleData } from './config.js';
export default {
  data: function data() {
    return {
      type: '',
      // 1周期内有入职，无离职 2周期内无入职，有离职
      visible: false,
      exampleTitle: exampleTitle(this),
      exampleData: exampleData(this),
      weeks: [this.$t('1121'), this.$t('1122'), this.$t('1123'), this.$t('1124'), this.$t('1125'), this.$t('1126'), this.$t('1127')]
    };
  },
  methods: {
    init: function init(type) {
      this.type = Number(type) - 1;
      this.visible = true;
    },
    handleClose: function handleClose() {
      this.visible = false;
    }
  }
};